<template>
  <div class="n8n-login">
    <!-- Loading Overlay -->
    <div class="n8n-loading-overlay" v-if="loading">
      <div class="n8n-loader">
        <div class="n8n-loader__spinner"></div>
        <span class="n8n-loader__text">กำลังเข้าสู่ระบบ...</span>
      </div>
    </div>

    <!-- Background Effects -->
    <div class="n8n-bg-effects">
      <div class="n8n-bg-gradient"></div>
      <div class="n8n-bg-glow n8n-bg-glow--1"></div>
      <div class="n8n-bg-glow n8n-bg-glow--2"></div>
    </div>

    <!-- Login Container -->
    <div class="n8n-login-container">
      <!-- Logo -->
      <div class="n8n-login-logo">
        <img src="../assets/images/logo2.png" alt="Logo" />
      </div>

      <!-- Card -->
      <div class="n8n-login-card">
        <!-- Header -->
        <div class="n8n-login-header">
          <div class="n8n-login-icon">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4"/>
              <polyline points="10 17 15 12 10 7"/>
              <line x1="15" y1="12" x2="3" y2="12"/>
            </svg>
          </div>
          <h1 class="n8n-login-title">Auto Login</h1>
          <p class="n8n-login-subtitle">เข้าสู่ระบบอัตโนมัติ</p>
        </div>

        <!-- Form -->
        <form class="n8n-login-form" @submit.prevent="login()">
          <!-- Username -->
          <div class="n8n-input-group">
            <label class="n8n-label">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/>
                <circle cx="12" cy="7" r="4"/>
              </svg>
              Username
            </label>
            <input
              type="text"
              class="n8n-input"
              placeholder="กรอก username"
              v-model="username"
              autocomplete="username"
            />
          </div>

          <!-- Password -->
          <div class="n8n-input-group">
            <label class="n8n-label">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                <path d="M7 11V7a5 5 0 0110 0v4"/>
              </svg>
              Password
            </label>
            <input
              type="password"
              class="n8n-input"
              placeholder="กรอก password"
              v-model="password"
              autocomplete="current-password"
            />
          </div>

          <!-- Error Message -->
          <div class="n8n-error" v-if="error">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
            <span>{{ message }}</span>
          </div>

          <!-- Submit Button -->
          <button type="submit" class="n8n-btn n8n-btn--primary">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4"/>
              <polyline points="10 17 15 12 10 7"/>
              <line x1="15" y1="12" x2="3" y2="12"/>
            </svg>
            <span>เข้าสู่ระบบ</span>
          </button>
        </form>

        <!-- Footer -->
        <div class="n8n-login-footer">
          <button type="button" class="n8n-link" @click="confirmForgotPassword()">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"/>
              <path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/>
              <line x1="12" y1="17" x2="12.01" y2="17"/>
            </svg>
            <span>ลืมรหัสผ่าน?</span>
          </button>
        </div>
      </div>

      <!-- Bottom Text -->
      <p class="n8n-login-bottom">
        UFA Easy888 • เว็บตรงไม่ผ่านเอเย่นต์
      </p>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/database";
import router from "./../router";
import liffService from "@/services/liff";
const axios = require("axios").default;

export default {
  name: "PlayLogin",
  created() {
    // LIFF is already initialized by router guard
    this.loadUserData();
  },
  data() {
    return {
      username: "",
      password: "",
      loading: true,
      userId: "",
      error: false,
      message: "Invalid user name or password!",
    };
  },
  methods: {
    async confirmForgotPassword() {
      if (confirm("ลืม password ใช่หรือป่าวคะ")) {
        await window.liff.sendMessages([
          {
            type: "text",
            text: "ลืม Password จ้า พลอยใสจัดการให้หน่อย😍😍"
          }
        ]);
        window.liff.closeWindow();
      }
    },
    login() {
      this.loading = true;
      this.error = false;
      axios({
        method: "post",
        url: "https://ufaeasy.apifast.xyz/login",
        data: {
          username: this.username.trim(),
          password: this.password.trim()
        }
      })
        .then(async response => {
          if (response.data.status && response.data.url) {
            this.error = false;
            this.message = '';
            if(window.liff.isInClient()){
              window.liff.openWindow({
                url: response.data.url,
                external: true
              });
              this.loading = false;
              window.liff.closeWindow();
            }else{
              this.loading = false;
              window.liff.openWindow({
                url: response.data.url,
                external: true
              });
            }
          } else {
            if(response.data.message){
              this.message = response.data.message;
            }
            this.loading = false;
            this.error = true;
          }
        })
        .catch(error => {
          // ต้องเป็น arrow function ไม่งั้น this ไม่ใช่ component
          // ของเดิมใช้ function ธรรมดา ทำให้ throw แล้วปุ่มหมุนค้างตลอด
          console.log("login error:", error && error.message);
          this.loading = false;
          this.error = true;
          this.message = "เชื่อมต่อระบบไม่ได้ กรุณาลองใหม่อีกครั้ง";
        });
    },
    async loadUserData() {
      const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
      
      // Get profile from centralized service (already fetched by router guard)
      let profile = liffService.profile;
      
      // Mock LIFF profile for localhost development
      if (isLocalhost && !profile) {
        profile = {
          userId: "UmockUserIdForDev",
          displayName: "Dev Tester",
          pictureUrl: "",
          statusMessage: ""
        };
      }

      if (!profile) return;

      this.userId = profile.userId || "";
      this.pictureUrl = profile.pictureUrl || "none";
      
      if (this.userId) {
        // Development mode on localhost - just show login form
        if (isLocalhost) {
          this.loading = false;
          return;
        }
        
        const users = (
          await firebase
            .database()
            .ref(`/users`)
            .orderByChild("userId")
            .equalTo(this.userId)
            .once("value")
        ).val();
        if (!users) {
          router.replace("/register");
        } else {
          let user = {};
          let key = '';
          for (const x in users) {
            user = users[x];
            key = x;
          }
          firebase
            .database()
            .ref(`/users/${key}`)
            .update({
              pictureUrl: profile.pictureUrl,
              linename: profile.displayName
            });
          axios({
            method: "post",
            url: "https://ufaeasy.apifast.xyz/login",
            data: {
              username: user.code,
              password: user.password
            }
          })
            .then(async response => {
              if (response.data.status && response.data.url) {
                window.liff.openWindow({
                  url: response.data.url,
                  external: true
                });
                this.loading = false;
                window.liff.closeWindow();
              } else {
                this.loading = false;
              }
            })
            .catch(error => {
              console.log("auto login error:", error && error.message);
              this.loading = false;
            });
        }
      }
    },
    async getFriendship() {
      const friend = await window.liff.getFriendship();
      if (!friend.friendFlag) {
        if (confirm("โปรด add @ufaeasy888v1 เป็นเพื่อน จะเพิ่มเลยไหม")) {
          window.location = "https://lin.ee/9MgANfz";
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
// ============================================================================
// N8N THEME - LOGIN PAGE
// ============================================================================

// Design Tokens
$n8n-bg: #0a0a0a;
$n8n-surface: #151515;
$n8n-surface-hover: #1f1f1f;
$n8n-border: rgba(255, 255, 255, 0.08);
$n8n-primary: #FF6B35;
$n8n-primary-soft: rgba(255, 107, 53, 0.15);
$n8n-gold: #f59e0b;
$n8n-gold-soft: rgba(245, 158, 11, 0.15);
$n8n-text: #ffffff;
$n8n-text-secondary: rgba(255, 255, 255, 0.6);
$n8n-text-muted: rgba(255, 255, 255, 0.4);
$n8n-error: #ef4444;
$n8n-radius: 16px;
$n8n-radius-sm: 12px;

.n8n-login {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  color: $n8n-text;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  position: relative;
  overflow: hidden;
  padding: 1.5rem;
}

// Background Effects
.n8n-bg-effects {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
}

.n8n-bg-gradient {
  position: absolute;
  inset: 0;
  background: 
    radial-gradient(ellipse 80% 50% at 50% -20%, rgba(255, 107, 53, 0.15), transparent),
    radial-gradient(ellipse 60% 40% at 100% 100%, rgba(245, 158, 11, 0.1), transparent);
}

.n8n-bg-glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.5;
  animation: n8n-float 20s ease-in-out infinite;
  
  &--1 {
    width: 400px;
    height: 400px;
    background: rgba(255, 107, 53, 0.2);
    top: -100px;
    right: -100px;
  }
  
  &--2 {
    width: 300px;
    height: 300px;
    background: rgba(245, 158, 11, 0.15);
    bottom: -50px;
    left: -50px;
    animation-delay: -10s;
  }
}

@keyframes n8n-float {
  0%, 100% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(20px, -20px) scale(1.1); }
}

// Loading Overlay
.n8n-loading-overlay {
  position: fixed;
  inset: 0;
  background: rgba(10, 10, 10, 0.9);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.n8n-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  
  &__spinner {
    width: 48px;
    height: 48px;
    border: 3px solid $n8n-border;
    border-top-color: $n8n-primary;
    border-radius: 50%;
    animation: n8n-spin 0.8s linear infinite;
  }
  
  &__text {
    color: $n8n-text-secondary;
    font-size: 0.95rem;
  }
}

@keyframes n8n-spin {
  to { transform: rotate(360deg); }
}

// Login Container
.n8n-login-container {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

// Logo
.n8n-login-logo {
  margin-bottom: 2rem;
  animation: n8n-fadeInDown 0.6s ease-out;
  
  img {
    height: 100px;
    width: auto;
    filter: drop-shadow(0 8px 32px rgba(255, 107, 53, 0.3));
  }
}

@keyframes n8n-fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// Card
.n8n-login-card {
  width: 100%;
  background: $n8n-surface;
  border: 1px solid $n8n-border;
  border-radius: $n8n-radius;
  padding: 2rem;
  animation: n8n-fadeInUp 0.6s ease-out 0.1s both;
  box-shadow: 
    0 4px 24px rgba(0, 0, 0, 0.4),
    0 0 0 1px rgba(255, 255, 255, 0.03) inset;
}

@keyframes n8n-fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// Header
.n8n-login-header {
  text-align: center;
  margin-bottom: 2rem;
}

.n8n-login-icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, $n8n-primary 0%, #B83F12 100%);
  border-radius: 14px;
  color: white;
  box-shadow: 0 8px 24px rgba(255, 107, 53, 0.35);
}

.n8n-login-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 0.5rem;
  background: linear-gradient(135deg, #fff 0%, rgba(255,255,255,0.85) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.n8n-login-subtitle {
  font-size: 0.9rem;
  color: $n8n-text-secondary;
  margin: 0;
}

// Form
.n8n-login-form {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}

.n8n-input-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.n8n-label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.85rem;
  font-weight: 500;
  color: $n8n-text-secondary;
  
  svg {
    color: $n8n-text-muted;
  }
}

.n8n-input {
  width: 100%;
  padding: 0.875rem 1rem;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid $n8n-border;
  border-radius: $n8n-radius-sm;
  color: $n8n-text;
  font-size: 1rem;
  transition: all 0.2s ease;
  
  &::placeholder {
    color: $n8n-text-muted;
  }
  
  &:focus {
    outline: none;
    border-color: $n8n-primary;
    background: rgba(255, 107, 53, 0.05);
    box-shadow: 0 0 0 3px rgba(255, 107, 53, 0.1);
  }
}

// Error
.n8n-error {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  padding: 0.875rem 1rem;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.2);
  border-radius: $n8n-radius-sm;
  color: $n8n-error;
  font-size: 0.875rem;
  animation: n8n-shake 0.4s ease-out;
  
  svg {
    flex-shrink: 0;
  }
}

@keyframes n8n-shake {
  0%, 100% { transform: translateX(0); }
  20% { transform: translateX(-8px); }
  40% { transform: translateX(8px); }
  60% { transform: translateX(-4px); }
  80% { transform: translateX(4px); }
}

// Button
.n8n-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.625rem;
  padding: 1rem 1.5rem;
  border: none;
  border-radius: 50px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 0.5rem;
  
  &--primary {
    background: linear-gradient(135deg, $n8n-primary 0%, #B83F12 100%);
    color: white;
    box-shadow: 0 4px 16px rgba(255, 107, 53, 0.35);
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 24px rgba(255, 107, 53, 0.45);
    }
    
    &:active {
      transform: translateY(0);
    }
  }
}

// Footer
.n8n-login-footer {
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid $n8n-border;
  text-align: center;
}

.n8n-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  color: $n8n-text-secondary;
  font-size: 0.9rem;
  cursor: pointer;
  transition: color 0.2s ease;
  
  &:hover {
    color: $n8n-primary;
  }
}

// Bottom Text
.n8n-login-bottom {
  margin-top: 2rem;
  font-size: 0.8rem;
  color: $n8n-text-muted;
  text-align: center;
  animation: n8n-fadeInUp 0.6s ease-out 0.2s both;
}
</style>
